<template>
  <div id="home">
    <!--引用公共头部-->
    <top-head></top-head>
    <header>
      <router-link to="StudyAim"><h1>{{resSubject}}</h1></router-link>
      <router-link to="PersonNote" style="display: none"><img src="../../assets/icon/home_icon_message.png" alt=""></router-link>
    </header>
    <!--轮播图-->
    <div class="lbt swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(item, index) in bannerData" :key="index"><a @click="wheretoGo(item.link_url, item.jump_type, item.signup)" ><img :src="item.path_url" width="100%" :alt="item.link_url"></a></div>
      </div>
      <div class="swiper-pagination"></div>
    </div>
    <!--导航-->
    <nav>
      <a @click="wheretoGo(item.href_url, item.jump_type, item.signup)"  v-for="(item, index) in navData" :key="index">
        <div>
          <img :src="item.image" :alt="item.href_url + '-' + item.jump_type">
          {{item.title}}
        </div>
      </a>
    </nav>
    <!--倒计时-->
    <div id="djs">
      <h2>{{djsData.title}} <span v-if="djsHudreds">{{djsHudreds}}</span> <span>{{djsTens}}</span> <span>{{djsOnes}}</span>
        {{djsData.day}}</h2>
      <router-link :to="{name: 'Calendar', query: {id: djsData.id}}">考试日历</router-link>
    </div>
    <!--领礼包-->
    <div id="gift">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item, index) in giftData" :key="index">
            <a :href="item.link_url" v-if="item.jump_type === 4" :alt="item.jump_type">
              <img :src="item.path_url" alt="">
            </a>
            <a @click="wheretoGo(item.link_url, item.jump_type, item.signup)" :alt="item.jump_type" v-else>
              <img :src="item.path_url" alt="">
            </a>
          </div>
        </div>
      </div>
    </div>
    <!--今日头条-->
    <div id="jrtt">
      <div class="title">
        <h3>今日头条</h3>
        <router-link :to="{name: 'ArticleList'}" class="tag">查看更多</router-link>
      </div>
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <ul class="swiper-slide" v-for="(item, index) in todayIndex" :key="index">
            <a :href="todayData[0 + item*2].href_url" v-if="todayData[0 + item*2]">
              <li>
                <div class="left">
                  <img :src="todayData[0 + item*2].img ? todayData[0 + item*2].img : require('../../assets/img/home_jrtt_pic1.png')" alt="todayData[0 + item*2].id">
                </div>
                <div class="right">
                  <p class="top">
                    {{todayData[0 + item*2].title}}
                  </p>
                  <div class="bottom">
                    {{todayData[0 + item*2].time}}
                    <div class="recommend">推荐</div>
                  </div>
                </div>
              </li>
            </a>
            <a :href="todayData[1 + index*2].href_url" v-if="todayData[1 + index*2]">
              <li>
                <div class="left">
                  <img :src="todayData[1 + index*2].img ? todayData[1 + index*2].img : require('../../assets/img/home_jrtt_pic2.png')" alt="todayData[1 + index*2].id">
                </div>
                <div class="right">
                  <p class="top">
                    {{todayData[1 + index*2].title}}
                  </p>
                  <div class="bottom">
                    {{todayData[1 + index*2].time}}
                    <div class="recommend">推荐</div>
                  </div>
                </div>
              </li>
            </a>
          </ul>
        </div>
        <div class="swiper-pagination"></div>
      </div>
    </div>
    <!--精品课程-->
    <div id="jpkc">
      <div class="title">
        <h3>精品课程</h3>
        <h6>已有 <span>6</span> <span>5</span> <span>2</span> <span>0</span> 名学员</h6>
        <p>学习以下课程通过考试</p>
        <router-link :to="{name: 'Jsbs'}" class="arrow"></router-link>
      </div>
      <div class="main" v-for="(item, index) in jpkcData" :key="index" @click="wheretoGo(item.id, 3, item.signup)">
        <div class="left"><img :src="item.app_img_1 ? item.app_img_1 : require('../../assets/img/home_jpkc_pic1.png')" alt=""></div>
        <div class="right">
          <h4>{{item.name}}</h4>
          <p>
            {{item.name_main}}
          </p>
          <div class="xx">学习：<b>{{item.sum_price}}人</b></div>
          <div class="ks">课时：<b>{{item.hours}}</b></div>
          <a @click="wheretoGo(item.id, 3, item.signup)" class="bmst" v-if="item.signup">去听课</a>
          <a @click="wheretoGo(item.id, 3, item.signup)" class="bmst" v-else>查看课程</a>
        </div>
      </div>
      <router-link :to="{name: 'Jsbs'}" class="ckqb">查看全部</router-link>
    </div>
    <!--最近更新-->
    <div id="zjgx">
      <div class="title">
        <h3>今日资讯</h3>
        <router-link :to="{name: 'ArticleList'}">查看全部</router-link>
      </div>
      <div class="main">
        <ul>
          <a :href="item.href_url" v-for="(item, index) in recentData" :key="index">
            <li v-if="index === 0">
              <div class="left">
                <img :src="item.img ? item.img : require('../../assets/img/home_zjgx_pic'+(index+1)+'.png')" alt="">
              </div>
              <div class="right">
                <p>
                  {{item.title}}
                </p>
                <div class="tag">
                  {{item.time}}
                </div>
              </div>
            </li>
            <li v-else class="noimg">
              <div class="left2">
                {{item.label ? item.label : '考试'}}
              </div>
              <p class="middle2">
                {{item.title}}
              </p>
              <div class="right2">
                {{item.time}}
              </div>
            </li>
          </a>
        </ul>
      </div>
      <router-link :to="{name: 'ArticleList'}" class="ckgd">
        查看更多
      </router-link>
    </div>
    <top-foot-three></top-foot-three>
    <!--底部占位-->
    <div id="fix-bottom-void"></div>
    <bottom-bar :index="0"></bottom-bar>
</div>
</template>

<script>
import BottomBar from '../share/fixed/BottomBar'
import topHead from '../share/header/topHead'
import topFootThree from '../share/footer/topFootThree'
import Swiper from 'swiper'
import jumpUrl from '../../assets/js/common'
/* eslint-disable no-new */
export default {
  name: 'Index',
  data () {
    return {
      // subject: this.$store.state.subject ? this.$store.state.subject : 1, // 1 教师资格证-笔试 、 2 教师资格证-面试、3 教师招聘-笔试、4 教师招聘-面试、1,2 教师资格证、3,4 教师招聘 多个使用,号拼接
      subject: 1,
      // period: this.$store.state.period ? this.$store.state.period : 2, // 学段 1中学 2小学 3幼儿  多个使用,号拼接
      period: 1, // 学段 1中学 2小学 3幼儿  多个使用,号拼接
      bannerData: {},
      bannerSwiperOb: null,
      navData: {},
      djsData: {},
      djsHudreds: 0,
      djsTens: 0,
      djsOnes: 0,
      giftData: {},
      giftSwiperOb: null,
      todayData: {},
      todayIndex: [0, 1, 2, 3, 4],
      todaySwiperOb: null,
      jpkcData: {},
      recentData: {}
    }
  },
  computed: {
    resSubject: function () {
      let result = ''
      switch (this.$store.state.subject) {
        case 1:
          // result = '教师资格-笔试'
          result = '教师资格证'
          break
        case 2:
          // result = '教师资格-面试'
          result = '教师资格证'
          break
        case 3:
          // result = '教师招聘-笔试'
          result = '教师招聘'
          break
        case 4:
          // result = '教师招聘-面试'
          result = '教师招聘'
          break
        case 0:
        default:
          result = '教师资格证'
          break
      }
      return result
      /*
      switch (this.$store.state.period) {
        case 1:
          result += '-' + '中学'
          break
        case 2:
          result += '-' + '小学'
          break
        case 3:
          result += '-' + '幼儿'
          break
        case 0:
        default:
          result += '-' + '小学'
          break
      }
      return result
      */
    }
  },
  components: {
    BottomBar,
    topHead,
    topFootThree
  },
  mounted () {
    this.getBanner()
    this.getNav()
    this.getDJS()
    this.getGIFT()
    this.getTodayNews()
    this.getJPKC()
    this.getRecent()
    this.validateToken()
  },
  methods: {
    // 获得 banner
    getBanner () {
      let data = {
        type: 1, // 放置位置 1 首页，2 课程页等
        page: 10,
        subject: this.subject,
        period: this.period
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_home_banner',
        params: data,
        headers: {
          'sign': this.$encryption(data)
        }
      })
        .then(res => {
          console.log('banner')
          console.log(res)
          this.bannerData = res.data.data
          let lbtState = true
          if (this.bannerData.length === 1) {
            lbtState = false
          }
          this.$nextTick(() => { // 下一帧渲染
            this.bannerSwiper(lbtState)
          })
        })
        .catch(err => { console.log(err) })
    },
    // 获得导航栏
    getNav () {
      let data = {
        subject: this.subject
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_home_navigation',
        params: data,
        headers: {
          'sign': this.$encryption(data)
        }
      })
        .then(res => { this.navData = res.data.data })
        .catch(err => { console.log(err) })
    },
    // 获得日历信息、倒计时
    getDJS () {
      let data = {
        subject: this.subject
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_home_countdown',
        params: data,
        headers: {
          'sign': this.$encryption(data)
        }
      })
        .then(res => {
          console.log('日历')
          console.log(res)
          this.djsData = res.data.data
          this.djsHudreds = parseInt((this.djsData.text % 1000) / 100)
          this.djsTens = parseInt((this.djsData.text % 100) / 10)
          this.djsOnes = parseInt(this.djsData.text % 10)
        })
        .catch(err => { console.log(err) })
    },
    // 获得礼包
    getGIFT () {
      let data = {
        subject: this.subject,
        period: this.period
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_home_welfare',
        params: data,
        headers: {
          'sign': this.$encryption(data)
        }
      })
        .then(res => {
          console.log('礼包')
          console.log(res)
          this.giftData = res.data.data
          this.$nextTick(() => { // 下一帧渲染
            this.giftSwiper()
          })
        })
        .catch(err => { console.log(err) })
    },
    // 获得今日头条
    getTodayNews () {
      let data = {
        page: 1, // 第几页
        length: 10 // 每页条数
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_home_headlines',
        params: data,
        headers: {
          'sign': this.$encryption(data)
        }
      })
        .then(res => {
          this.todayData = res.data.data
          this.$nextTick(() => { // 下一帧渲染
            this.todaySwiper()
          })
        })
        .catch(err => { console.log(err) })
    },
    // 获得精品课程
    getJPKC () {
      let data = {
        page: 1,
        subject: this.subject,
        period: this.period
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_home_recent_course',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          console.log('精品课：')
          console.log(res)
          this.jpkcData = res.data.data
        })
        .catch(err => { console.log(err) })
    },
    // 获得最近更新
    getRecent () {
      let data = {
        page: 1, // 第几页
        length: 4 // 每页条数
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_home_latest_news',
        params: data,
        headers: {
          'sign': this.$encryption(data)
        }
      })
        .then(res => {
          console.log('今日资讯')
          console.log(res)
          this.recentData = res.data.data
        })
        .catch(err => { console.log(err) })
    },
    bannerSwiper (playState) {
      this.bannerSwiperOb = new Swiper('.lbt.swiper-container', {
        speed: 500,
        autoplay: {
          autoplay: true,
          delay: 2000
        },
        loop: playState,
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, // 修改swiper的父元素时，自动初始化swiper
        pagination: {
          el: '.lbt .swiper-pagination'
        }
      })
    },
    giftSwiper () {
      this.giftSwiperOb = new Swiper('#gift .swiper-container', {
        slidesPerView: 3,
        spaceBetween: '4.27%',
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true // 修改swiper的父元素时，自动初始化swiper
      })
    },
    todaySwiper () {
      this.todaySwiperOb = new Swiper('#jrtt .swiper-container', {
        pagination: {
          el: '#jrtt .swiper-pagination',
          bulletClass: 'bullet',
          bulletActiveClass: 'bullet-active'
        },
        on: {
          init: function () {
            let _total = this.slides.length
            $('#jrtt .total').text(_total)
            this.emit('transitionEnd')
          },
          transitionEnd: function () {
            let _index = this.realIndex + 1
            $('#jrtt .active').text(_index)
          }
        },
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true // 修改swiper的父元素时，自动初始化swiper
      })
    },
    wheretoGo (classId, jumpType, signUp) {
      if (jumpType === 11) {
        this.easyChat()
        return false
      }
      jumpUrl(classId, jumpType, signUp)
    },
    validateToken () {
      let data = {
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/overdue_user_token',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          console.log('验证登录：')
          console.log(res)
          if (res.data.errcode !== 200) {
            this.$store.dispatch('alterName', '')
            this.$store.dispatch('alterNickname', '')
            this.$store.dispatch('alterPortrait', '')
            this.$store.dispatch('alterSchool', '')
            this.$store.dispatch('alterToken', '')
            this.$store.dispatch('alterUid', '')
            this.$store.dispatch('alterVipname', '')
            this.$store.dispatch('alterViptime', '')
          }
        })
        .catch(err => { console.log(err) })
    },
    easyChat () {
      this.$easyliao(12523, 20523)
      return false
    }
  }
}

</script>

<style scoped lang="stylus">
  #home
    overflow: hidden
    width: 100%
    max-width: 7.5rem
    height: 100%
    padding: 0 .2rem
    background: -webkit-linear-gradient(top, #fff, #EDEDED) /* Safari 5.1 - 6.0 */
    background: -o-linear-gradient(bottom, #fff, #EDEDED) /* Opera 11.1 - 12.0 */
    background: -moz-linear-gradient(bottom, #fff, #EDEDED) /* Firefox 3.6 - 15 */
    background: linear-gradient(to bottom, #fff, #EDEDED) /* 标准的语法 */
    -webkit-box-sizing: border-box
    -moz-box-sizing: border-box
    box-sizing: border-box
    header
      display: flex
      display: none
      justify-content: space-between
      align-items: center
      width: 100%
      height: .74rem
      margin: 0 auto
      h1
        position: relative
        font-size: .34rem
        color: #050505
        font-weight: bold
        text-align: left
        &::before
          content: "切换"
          position: absolute
          top: .04rem
          right: -.9rem
          display: inline-block
          font-size: .28rem
          color: #5E5E5E
          opacity: .6
        &::after
          content: ""
          position: relative
          top: .02rem
          right: -.2rem
          display: inline-block
          width: .34rem
          height: .28rem
          background: url(../../assets/icon/index_icon_switch.png) no-repeat center
          -webkit-background-size: 100%
          background-size: 100%
      h1 + a
        display: inline-block
        width: .36rem
        height: .36rem
        img
          width: 100%
  .lbt
    width: 7.1rem
    margin: .12rem auto 0
    >>> .swiper-pagination-bullet
      width: .28rem
      height: .06rem
      background-color: #ccc
      -webkit-border-radius: .05rem
      -moz-border-radius: .05rem
      border-radius: .05rem
      &.swiper-pagination-bullet-active
        background-color: #fff
        opacity: .8
    img
      -webkit-border-radius: .16rem
      -moz-border-radius: .16rem
      border-radius: .16rem

  nav
    display: flex
    justify-content: space-around
    margin-top: .2rem
    div
      text-align: center
      img
        display: block
        width: .5rem
        height: .5rem
        margin: 0 auto .1rem
      p
        text-align: center
  #djs
    display: flex
    justify-content: space-between
    align-items: center
    width: 7.1rem
    height: 1rem
    background-color: #F4F4F4
    margin-top: .2rem
    font-size: .28rem
    color: #333
    -webkit-border-radius: .2rem
    -moz-border-radius: .2rem
    border-radius: .2rem
    h2
      line-height: 1rem
      padding-left: .7rem
      background: url(../../assets/icon/home_icon_time.png) no-repeat .24rem center
      -webkit-background-size: .32rem
      background-size: .32rem
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      span
        display: inline-block
        width: .36rem
        height: .42rem
        line-height: .42rem
        background: url(../../assets/icon/home_icon_djs.png) no-repeat center
        -webkit-background-size: 100%
        background-size: 100%
        color: #fff
        text-align: center
    a
      width: 1.7rem
      height: .52rem
      line-height: .52rem
      border: .01rem solid #FF7052
      padding-left: .2rem
      background: url(../../assets/icon/home_icon_fire.png) no-repeat .1rem center
      margin-right: .2rem
      -webkit-background-size: .22rem .28rem
      background-size: .22rem .28rem
      color: #FF7052
      text-align: center
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      -webkit-border-radius: .26rem
      -moz-border-radius: .26rem
      border-radius: .26rem
  #gift
    position: relative
    overflow: hidden
    width: 7.1rem
    height: 1.36rem
    margin: .34rem auto
    .swiper-container
      position: absolute
      top: 0
      left: 0
      overflow: hidden
      width: 7.3rem
      height: 1.36rem
      .swiper-slide
        width: 2.36rem
        height: 1.36rem
        /*padding: .2rem*/
        background: url(../../assets/img/home_gift_bg1.png) no-repeat right bottom #fff
        -webkit-background-size: .36rem
        background-size: .36rem
        -webkit-border-radius: .08rem
        -moz-border-radius: .08rem
        border-radius: .08rem
        -webkit-box-sizing: border-box
        -moz-box-sizing: border-box
        box-sizing: border-box
        &:nth-of-type(3n+2)
          background-image: url(../../assets/img/home_gift_bg2.png)
        &:nth-of-type(3n)
          background-image: url(../../assets/img/home_gift_bg3.png)
        h4
          font-size: .26rem
          color: #050505
        p
          overflow: hidden
          width: 100%
          margin: .02rem 0
          font-size: .22rem
          color: #9DA4B3
          &.color
            color: #FF7052
        img
          width: 100%
          height: 100%
  #jrtt
    width: 7.1rem
    height: 5.32rem
    padding: 0 .2rem
    background-color: #fff
    -webkit-border-radius: .16rem
    -moz-border-radius: .16rem
    border-radius: .16rem
    -webkit-box-sizing: border-box
    -moz-box-sizing: border-box
    box-sizing: border-box
    .title
      display: flex
      justify-content: space-between
      align-items: center
      width: 100%
      height: .92rem
      border-bottom: .01rem solid #EFEFEF
      h3
        line-height: .92rem
        font-size: .36rem
        color: #050505
        font-weight: 600
      .tag
        color: #a3a9b7
    .swiper-container
      padding-bottom: .4rem
    .swiper-slide
      height: 3.8rem
      li
        display: flex
        justify-content: space-between
        width: 100%
        height: 1.88rem
        padding: .32rem .04rem
        border-bottom: .01rem solid #EFEFEF
        -webkit-box-sizing: border-box
        -moz-box-sizing: border-box
        box-sizing: border-box
        .left
          width: 1.6rem
          height: 1.24rem
          -webkit-border-radius: .08rem
          -moz-border-radius: .08rem
          border-radius: .08rem
          img
            width: 100%
        .right
          width: 4.9rem
          height: 1.24rem
          p.top
            height: .84rem
            font-size: .3rem
            color: #0C0C0C
          div.bottom
            font-size: .22rem
            color: #9DA4B3
            text-align: right
            .recommend
              display: inline-block
              width: .52rem
              height: .36rem
              line-height: .34rem
              border: .01rem solid #FF7052
              font-size: .22rem
              color: #FF7052
              text-align: center
    .swiper-pagination
      bottom: 0
  #jpkc
    width: 7.1rem
    background-color: #fff
    padding-bottom: .32rem
    margin-top: .32rem
    margin-bottom: .32rem
    -webkit-border-radius: .16rem
    -moz-border-radius: .16rem
    border-radius: .16rem
    .title
      position: relative
      overflow: hidden
      width: 100%
      height: 1.88rem
      background: url(../../assets/img/ home_jpkc_bg_title.png) no-repeat center
      -webkit-background-size: 100%
      background-size: 100%
      h3
        margin: .2rem
        font-size: .36rem
        color: #fff
        text-align: left
      h6
        font-size: .28rem
        color: #252E4C
        text-align: center
        span
          display: inline-block
          width: .36rem
          height: .36rem
          line-height: .36rem
          background-color: #252E4C
          font-size: .32rem
          color: #fff
          text-align: center
      h6 + p
        line-height: .56rem
        font-size: .4rem
        color: #FF7052
        font-weight: 500
        text-align: center
      a.arrow
        position: absolute
        top: .2rem
        right: .2rem
        display: block
        width: .44rem
        height: .44rem
        background: url(../../assets/img/home_jpkc_arrow.png) no-repeat center
        -webkit-background-size: 100%
        background-size: 100%
    .main
      display: flex
      justify-content: space-between
      width: 6.7rem
      height: 2.24rem
      margin: .32rem auto
      .left
        width: 2.28rem
        height: 2.24rem
        -webkit-border-radius: .08rem
        -moz-border-radius: .08rem
        border-radius: .08rem
        img
          width: 100%
      .right
        position: relative
        width: 4.22rem
        height: 2.24rem
        h4
          line-height: .5rem
          font-size: .32rem
          color: #0C0C0C
          font-weight: bold
          text-align: left
        p
          line-height: .35rem
          font-size: .24rem
          color: #9DA4B3
          text-align: left
        div.xx
          display: none
          line-height: .38rem
          font-size: .25rem
          color: #9DA4B3
          b
            font-size: .3rem
        div.ks
          line-height: .38rem
          font-size: .25rem
          color: #9DA4B3
          b
            font-size: .3rem
            color: #FF7052
        a.bmst
          position: absolute
          bottom: 0
          right: 0
          display: block
          width: 1.52rem
          height: .56rem
          line-height: .56rem
          background-color: #FF7052
          font-size: .24rem
          color: #fff
          text-align: center
          -webkit-border-radius: .34rem
          -moz-border-radius: .34rem
          border-radius: .34rem
    a.ckqb
      display: block
      width: 6.7rem
      height: .88rem
      line-height: .88rem
      background-color: #F4F3F1
      margin: 0 auto
      font-size: .28rem
      color: #FF7052
      text-align: center
      -webkit-border-radius: .16rem
      -moz-border-radius: .16rem
      border-radius: .16rem
  #zjgx
    width: 7.1rem
    padding: 0 .2rem .3rem
    background-color: #fff
    margin-top: .32rem
    -webkit-border-radius: .16rem
    -moz-border-radius: .16rem
    border-radius: .16rem
    -webkit-box-sizing: border-box
    -moz-box-sizing: border-box
    box-sizing: border-box
    .title
      display: flex
      justify-content: space-between
      align-items: center
      width: 100%
      height: .9rem
      border-bottom: .01rem solid #EFEFEF
      h3
        font-size: .36rem
        color: #050505
        font-weight: 600
        text-align: left
      h3 + a
        font-size: .24rem
        color: #A3A9B7
    .main
      li
        display: flex
        justify-content: space-between
        width: 100%
        height: 1.8rem
        padding: .25rem 0
        border-bottom: .01rem solid #EFEFEF
        -webkit-box-sizing: border-box
        -moz-box-sizing: border-box
        box-sizing: border-box
        .left
          width: 1.6rem
          height: 1.24rem
          -webkit-border-radius: .08rem
          -moz-border-radius: .08rem
          border-radius: .08rem
          img
            width: 100%
        .right
          width: 4.9rem
          height: 1.24rem
          p
            overflow: hidden
            width: 100%
            height: .84rem
            font-size: .3rem
            color: #0C0C0C
          p + .tag
            font-size: .22rem
            color: #9DA4B3
            text-align: right
        &.noimg
          display: flex
          justify-content: space-between
          align-items: center
          height: auto
          .left2
            width: .6rem
            height: .42rem
            overflow: hidden
            line-height: .4rem
            border: .01rem solid #1E81F2
            font-size: .26rem
            color: #1E81F2
            text-align: center
            -webkit-border-radius: .03rem
            -moz-border-radius: .03rem
            border-radius: .03rem
            -webkit-box-sizing: border-box
            -moz-box-sizing: border-box
            box-sizing: border-box
          .middle2
            width: 4.9rem
            font-size: .3rem
            color: #0C0C0C
            text-align: left
          .right2
            width: .8rem
            height: .34rem
            line-height: .34rem
            font-size: .24rem
            color: #9DA4B3
            text-align: center
    .ckgd
      position: relative
      top: -.2rem
      display: block
      width: 100%
      height: .4rem
      line-height: .6rem
      background-color: #fff
      font-size: .3rem
      color: #aaa
      text-align: center
      &::before
        content: ""
        position: absolute
        top: -.5rem
        left: 0
        width: 100%
        height: .5rem
        background-image: linear-gradient(rgba(255, 255, 255, .1), rgba(255, 255, 255, 1))
  #fix-bottom-void
    height: 1rem
    clear: both
  #jrtt .swiper-pagination >>> .bullet
    width: .48rem
    height: .08rem
    display: inline-block
    background-color: rgba(220,220,220,1)
    margin: 0 .16rem
    -webkit-border-radius: .04rem
    -moz-border-radius: .04rem
    border-radius: .04rem
  #jrtt .swiper-pagination >>> .bullet-active
    background-color: rgba(88,88,88,1)
    opacity: 1
</style>



// WEBPACK FOOTER //
// src/components/webs/Index.vue